<template>
  <div class="field">
    <field-label v-if="label" v-bind="{
      required,
      requiredClass,
      requiredText,
      hint,
      hintIcon,
      hintIconPack,
      hintIconType,
      hintClass,
      description
    }"><slot/></field-label>
    <p :class="['field-description', descriptionClass]" v-if="description">{{ description }}</p>
    <component :is="element" ref="editor" v-html="value" />
    <field-error v-if="hasError" v-bind="{ error, errorClass, errorSymbol }" />
  </div>
</template>

<script>
import './vendor/redactor'
import * as props from '@billow/vue-bulma/components/mixins/props'
import * as computed from '@billow/vue-bulma/components/mixins/computed'

export default {

  mixins: [
    props.error,
    props.describable,
    props.hintable,
    props.required,
    props.label,

    computed.hasError,
  ],

  props: {
    value: {
      type: String,
      default: '',
    },
    element: {
      type: String,
      default: 'textarea'
    },
    sourceSync: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    plugins: {
      type: Array,
      default: () => ([]),
    },
    imageUpload: {
      type: Boolean | Function,
      default: false,
    },
  },

  data: () => ({
    editor: undefined,
  }),

  mounted() {
    let defaultOptions = {
      source: false,
      plugins: this.plugins,
      callbacks: {
        syncing: this.emit,
        source: { changed: this.sourceSync ? this.emit : null }
      }
    }

    // Check if we need to allow image uploads and apply the callback
    if (this.imageUpload) {
      defaultOptions.imageUpload = this.imageUpload
    }

    let options = Object.assign(defaultOptions, this.options)

    this.editor = $R(this.$refs.editor, options)
  },

  methods: {
    emit(input) {
      this.$emit('input', input)
    },
  }

}
</script>
